import Phaser from 'phaser';
import { COLORS, HEX } from '../constants/colors';

export class GameOverScene extends Phaser.Scene {
  private finalScore = 0;

  constructor() {
    super({ key: 'GameOverScene' });
  }

  init(data: { score: number; defense: number }): void {
    this.finalScore = data.score;
  }

  create(): void {
    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor(COLORS.black);

    this.add
      .text(width / 2, height / 2 - 100, 'ЛЕС ПОРАЖЁН', {
        fontFamily: 'Arial',
        fontSize: '48px',
        color: HEX.red,
        fontStyle: 'bold',
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height / 2, `Очки: ${this.finalScore}`, {
        fontFamily: 'Arial',
        fontSize: '32px',
        color: HEX.white,
      })
      .setOrigin(0.5);

    const restartButton = this.add
      .text(width / 2, height / 2 + 100, 'СЫГРАТЬ ЕЩЁ', {
        fontFamily: 'Arial',
        fontSize: '32px',
        color: HEX.white,
        fontStyle: 'bold',
        backgroundColor: HEX.midGray,
        padding: { x: 20, y: 12 },
      })
      .setOrigin(0.5);

    restartButton.setInteractive({ useHandCursor: true });
    restartButton.on('pointerover', () => restartButton.setBackgroundColor(HEX.lightGray));
    restartButton.on('pointerout', () => restartButton.setBackgroundColor(HEX.midGray));
    restartButton.on('pointerdown', () => this.scene.start('GameScene'));

    this.input.keyboard?.once('keydown-SPACE', () => this.scene.start('GameScene'));
  }
}
